import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

import { InvestorsComponent } from './components/investors.component';
import { InvestorDetailsComponent } from './components/investor-details.component';

@NgModule({
  declarations: [InvestorsComponent, InvestorDetailsComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class InvestorsModule { }
